import { render, staticRenderFns } from "./historytaking.vue?vue&type=template&id=58a7af1b&"
import script from "./historytaking.vue?vue&type=script&lang=js&"
export * from "./historytaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports